/**
 * @description Channel Partner admin Dashboard — collapsible checklist shell (LYN-309)
 *
 * @notes Exact checklist rows are still discussion. Do not implement rows.
 */

import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function ChannelPartnerDashboard() {
  const [open, setOpen] = useState(true);

  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
      <p className="text-sm text-gray-500 mt-1">Channel Partner admin</p>

      <div className="mt-6 border border-gray-200 rounded-xl bg-white">
        <button
          type="button"
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
          className="w-full flex items-center justify-between px-4 py-3 text-left"
        >
          <span className="text-sm font-medium text-gray-900">Setup checklist</span>
          <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
        {open && (
          <div className="px-4 pb-4 text-sm text-gray-500 border-t border-gray-100 pt-3">
            Checklist items will land here after they are walked. This is the shell only.
          </div>
        )}
      </div>
    </div>
  );
}
